module.exports = __webpack_public_path__ + "media/images/house-4855cf8ac15d14b1c0eb34b8a6fc56ce.svg";